import Decimal from 'decimal.js';

type RatioQuantity = string | number | null | undefined;

export function isPositiveRatioQuantity(value: RatioQuantity): boolean {
  if (value == null || !/^\d+(\.\d+)?$/.test(String(value)) || !Number.isFinite(Number(value))) return false;
  return new Decimal(value).gt(0);
}

export function corporateActionRatioError(type: string, oldUnits: RatioQuantity, newUnits: RatioQuantity): string | undefined {
  if (!isPositiveRatioQuantity(oldUnits) || !isPositiveRatioQuantity(newUnits)) return;
  const comparison = new Decimal(newUnits!).cmp(oldUnits!);
  if (type === 'consolidation' && comparison >= 0) return 'A share consolidation must have fewer new units than old units. For example, 5 old shares become 1 new share.';
  if (type === 'split' && comparison <= 0) return 'A share split must have more new units than old units. For example, 1 old share becomes 5 new shares.';
}
